import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import { includedName } from "_constants";
import breakpoints from "_constants/breakpoints";

const Container = styled.div`
  padding: 36px 32px 36px;
  margin-bottom: 24px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 26px 12px 12px;
  }
`;
const Title = styled.h1`
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      margin-bottom: 0;
      text-align: center;
    `}
`;
const SubTitle = styled.h2`
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      text-align: center;
    `}
`;
const InfoSection = styled.div`
  border-top: 1px solid #ecedf1;
  &:last-child {
    border-bottom: 1px solid #ecedf1;
  }
`;
const FirstRowInfo = styled.div`
  display: flex;
  min-height: 40px;
  height: 100%;
  align-items: center;
  padding: 5px 0;

  @media (max-width: ${breakpoints.mobileM}) {
    flex-direction: column;
    min-height: 64px;
  }
`;
const SecondRowInfo = styled(FirstRowInfo)`
  background-color: #fafaff;
`;
const LableCell = styled.div`
  width: 50%;
  padding-left: 14px;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #7b848d;

  @media (max-width: ${breakpoints.mobileM}) {
    width: 100%;
    padding-left: 0px;
    text-align: center;
  }
`;
const DataCell = styled(LableCell)`
  width: 50%;
  font-weight: bold;
  white-space: normal;
  word-break: break-all;
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  text-align: center;
  font-weight: bold;
`;

function TrademarkRegisterDetails({ registerDetails }) {
  return (
    <Container>
      {registerDetails ? (
        <>
          <Title>Trademark Details</Title>
          <SubTitle>Your order information</SubTitle>

          <InfoSection>
            <FirstRowInfo>
              <LableCell>Serial Number</LableCell>
              <DataCell>{registerDetails?.processingResult.serialNumber || "—"}</DataCell>
            </FirstRowInfo>

            <SecondRowInfo>
              <LableCell>Trademark</LableCell>
              <DataCell>{registerDetails?.markDesc || "—"}</DataCell>
            </SecondRowInfo>
          </InfoSection>

          <InfoSection>
            <FirstRowInfo>
              <LableCell>Trademark Type</LableCell>
              <DataCell>{registerDetails?.trademarkType || "—"}</DataCell>
            </FirstRowInfo>

            <SecondRowInfo>
              <LableCell>Protect All Colors</LableCell>
              <DataCell>{registerDetails?.logoColoredVariety ? "Yes" : "No"}</DataCell>
            </SecondRowInfo>
          </InfoSection>

          <InfoSection>
            <FirstRowInfo>
              <LableCell>Custom Logo</LableCell>
              <DataCell>{registerDetails?.literalElements || "—"}</DataCell>
            </FirstRowInfo>

            <SecondRowInfo>
              <LableCell>Colors in Logo</LableCell>
              <DataCell>{registerDetails?.colorsInLogo}</DataCell>
            </SecondRowInfo>
          </InfoSection>

          <InfoSection>
            <FirstRowInfo>
              <LableCell>Included Name</LableCell>
              <DataCell>{includedName[registerDetails?.includedName]}</DataCell>
            </FirstRowInfo>

            <SecondRowInfo>
              <LableCell>
                {registerDetails?.includedName === "NONE" ? "Name" : includedName[registerDetails?.includedName]}
              </LableCell>
              <DataCell>{registerDetails?.includedNameValue}</DataCell>
            </SecondRowInfo>
          </InfoSection>

          <InfoSection>
            <FirstRowInfo>
              <LableCell>Need Translation</LableCell>
              <DataCell>{registerDetails?.includeTranslationWords ? "Yes" : "No"}</DataCell>
            </FirstRowInfo>

            <SecondRowInfo>
              <LableCell>Translation</LableCell>
              <DataCell>{registerDetails?.translation || "—"}</DataCell>
            </SecondRowInfo>
          </InfoSection>

          <InfoSection>
            <FirstRowInfo>
              <LableCell>In Use</LableCell>
              <DataCell>{registerDetails?.currentTrademark ? "Yes" : "No"}</DataCell>
            </FirstRowInfo>

            <SecondRowInfo>
              <LableCell>First Use Anywhere</LableCell>
              <DataCell>{registerDetails?.firstUseAnywhere || "—"}</DataCell>
            </SecondRowInfo>
          </InfoSection>

          <InfoSection>
            <FirstRowInfo>
              <LableCell>First Use in Commerce</LableCell>
              <DataCell>{registerDetails?.firstUseInCommerce || "—"}</DataCell>
            </FirstRowInfo>

            <SecondRowInfo>
              <LableCell>Website</LableCell>
              <DataCell>{registerDetails?.website || "—"}</DataCell>
            </SecondRowInfo>
          </InfoSection>

          <InfoSection>
            <FirstRowInfo>
              <LableCell>Specimen Description</LableCell>
              <DataCell>{registerDetails?.specimenDescription || "—"}</DataCell>
            </FirstRowInfo>
          </InfoSection>
        </>
      ) : (
        <EmptyMessage>No additional details for this order.</EmptyMessage>
      )}
    </Container>
  );
}

TrademarkRegisterDetails.propTypes = {
  registerDetails: PropTypes.object,
};

export default TrademarkRegisterDetails;
